const weatherIconMap = new Map()
weatherIconMap.set('Soleil', 'Sunny')
weatherIconMap.set('Nuageux', 'Cloudy')
weatherIconMap.set('Brouillard', 'Foggy')
weatherIconMap.set('Pluie', 'Raining')
weatherIconMap.set('Averses', 'Raining')
weatherIconMap.set('Neige', 'Snowing')
weatherIconMap.set('Orages', 'Lightning_Cloudy')

export default weatherIconMap